<template>
    <div>

        <navbar></navbar>

        <info-modal v-on:close="closeInfo" :headline="infoModal.headline"
                    :subline="infoModal.subline" :body="infoModal.body"></info-modal>

        <div class="bg-header-round-small">
            <div class="container">
                <h1>Meine Bestellung</h1>
                <button @click.prevent="goTo('profile', {}, {'tab': 'orders'})"
                        class="btn orange mt-4 mx-auto">Zurück
                </button>
            </div>
        </div>

        <div v-if="!order" class="flex items-center">
            <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
                <cg-loader :show="true"></cg-loader>
            </div>
        </div>

        <div v-if="order" class="container relative">

            <h2 class="mt-0 pt-0 italic">Dein Einkauf bei {{ order.shop.name }} vom {{ formatDate(order.created_at)
                }}</h2>

            <p><span class="font-bold">Bestellstatus:</span> {{ getStatus(order) }}</p>

            <order-summary class="relative lg:absolute xl:absolute pin-t pin-r lg:mt-13x md:mb-6x"></order-summary>
            <div class="flex">
                <div class="w-full md:w-2/4 lg:w-2/4 xl:w-2/4">
                    <h2>Lieferadresse</h2>
                    <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
                        <div :class="['card simple-card', 'selected']">
                            <div class="chosen">
                                <span>Ausgewählt</span>
                                <icon name="check"></icon>
                            </div>
                            <div class="address">
                                <h6>{{ deliveryAddress.first_name + ' ' + deliveryAddress.last_name }}</h6>
                                <span v-if="deliveryAddress.company">{{ deliveryAddress.company }}</span>
                                <span>{{ deliveryAddress.street + deliveryAddress.number }}</span>
                                <span>{{ deliveryAddress.city }}, {{ deliveryAddress.region }} {{ deliveryAddress.zip }}</span>
                                <span>{{ deliveryAddress.country }}</span>
                                <span v-if="deliveryAddress.tel">{{ deliveryAddress.tel }}</span>
                            </div>
                        </div>
                    </div>
                    <h2>Rechnungsadresse</h2>
                    <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
                        <div :class="['card simple-card', 'selected']">
                            <div class="chosen">
                                <span>Ausgewählt</span>
                                <icon name="check"></icon>
                            </div>
                            <div class="address">
                                <h6>{{ invoiceAddress.first_name + ' ' + invoiceAddress.last_name }}</h6>
                                <span v-if="invoiceAddress.company">{{ invoiceAddress.company }}</span>
                                <span>{{ invoiceAddress.street + invoiceAddress.number }}</span>
                                <span>{{ invoiceAddress.city }}, {{ invoiceAddress.region }} {{ invoiceAddress.zip }}</span>
                                <span>{{ invoiceAddress.country }}</span>
                                <span v-if="invoiceAddress.tel">{{ invoiceAddress.tel }}</span>
                            </div>
                        </div>
                    </div>
                    <h2>Zahlungsart</h2>
                    <div v-if="!hasToPay" class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
                        <div class="card simple-card" :class="['selected']">
                            <div class="chosen">
                                <span>Ausgewählt</span>
                                <icon name="check"></icon>
                            </div>
                            <div class="card-media-wrapper">
                                <img :src="'/static/icon-' + paymentMethod.card_brand.replace(/ /g, '_') + '.png'" alt="">
                                <div class="address">
                                    <h6>{{ paymentMethod.card_brand }}</h6>
                                    <span>endet auf {{ paymentMethod.card_last4 }}</span>
                                    <span>Ablaufdatum: {{ paymentMethod.card_exp_month }}/{{ paymentMethod.card_exp_year }}</span>
                                    <span>Karteninhaber: {{ paymentMethod.cardholder_name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <payment-methods v-if="hasToPay" :title="''" :selected="paymentMethod"
                                     v-on:selected="selectPaymentMethod"></payment-methods>
                </div>
            </div>
            <shop-slider v-if="similarShops.data.length" :shops="similarShops" title="Weiter einkaufen"></shop-slider>
        </div>

        <cgfooter></cgfooter>

    </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'
  import ShopSlider from '../components/slider/shopSlider'
  import {mapGetters, mapActions} from 'vuex'
  import formatting from '@/mixins/formatting.js'
  import helpers from '@/mixins/helpers.js'
  import OrderSummary from '../components/user/orderSummary'
  import InfoModal from '../components/modals/info'
  import PaymentMethods from '../components/user/paymentMethods'
  import CgLoader from '../components/menus/cgLoader'
  import {EventBus} from '@/assets/js/event-bus.js'

  export default {
    name: 'Order',
    components: {
      InfoModal,
      CgLoader,
      PaymentMethods,
      OrderSummary,
      ShopSlider,
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [formatting, helpers],
    data () {
      return {
        infoModal: {
          headline: '',
          subline: '',
          body: '',
          show: false
        }
      }
    },
    created () {
      var self = this
      this.getOrder({
        order: this.$route.params.order,
        cb (order) {
          if (self.showMessage) {
            self.setMessage(order)
          }
          self.getShopTeaserList({shop: order.shop.uid})
        },
        errorCb () {
          self.$toasted.error('Diese Bestellung konnte nicht gefunden werden.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
        }
      })
    },
    methods: {
      ...mapActions([
        'getOrder',
        'getShopTeaserList'
      ]),
      closeInfo () {
        this.infoModal.show = false
        EventBus.$emit('toggleInfoModal')
      },
      selectPaymentMethod (pm) {
        // for a future in which he can reselect after having failed payment
      },
      setMessage (order) {
        this.$store.commit('CHECKOUT_SET_CART_JUST_INTO_ORDER', false)
        if (this.isOrderPaid(order)) {
          this.infoModal = {
            'headline': 'Vielen Dank für Deine Bestellung!',
            'subline': 'Deine Bestellung bei dem Händler ' + order.shop.name + ' war erfolgreich.',
            'body': 'Deine Lieferung wird jetzt vorbereitet und Du wirst informiert, sobald sich Deine Bestellung auf den Weg zu Dir macht - Vorfreude ist die schönste Freude!',
            'show': true
          }
        } else if (this.isOrderPaymentWarning(order)) {
          this.infoModal = {
            'headline': 'Ups!',
            'subline': 'Leider gab es ein Problem beim Bezahlen.',
            'body': 'Bitte kontaktiere unseren Support!',
            'show': true
          }
        } else if (this.isOrderPaymentPending(order)) {
          this.infoModal = {
            'headline': 'Vielen Dank!',
            'subline': 'Deine Bestellung bei ' + order.shop.name + ' ist eingegangen.',
            'body': 'Die Zahlung wird erst durchgeführt, wenn der Händler die Bestellung bestätigt. Es kann passieren, dass der Betrag niedriger ausfällt.',
            'show': true
          }
        }
        if (this.infoModal.show) {
          EventBus.$emit('toggleInfoModal')
        }
      },
      getStatus (order) {
        var st = this.getOrderStatusText(order)
        var text = st[0]
        if (st[1] !== '') {
          text = text + ', ' + st[1]
        }
        return text
      }
    },
    computed: {
      hasToPay () {
        // this would allow re choosing the pay detail
        return false // !this.isOrderPaid(this.order) && this.isOrderPaymentWarning(this.order)
      },
      ...mapGetters({
        authenticated: 'auth_is_authenticated',
        account: 'auth_get_account',
        order: 'checkout_get_order',
        loading: 'options_is_loading',
        deliveryAddress: 'checkout_get_order_address',
        invoiceAddress: 'checkout_get_order_invoice_address',
        paymentMethod: 'checkout_get_order_paymentMethod',
        carrier: 'checkout_get_order_carrier',
        similarShops: 'shop_get_teaser_list',
        showMessage: 'checkout_cart_just_into_order'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Order.vue